var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.0075C21.0022 14.745 20.9013 14.492 20.7189 14.3032L12.708 6.29337C12.6147 6.20061 12.5042 6.12712 12.3825 6.0771C12.2614 6.02621 12.1314 6 12 6C11.8686 6 11.7386 6.02621 11.6175 6.0771C11.4958 6.12712 11.3853 6.20061 11.292 6.29337L3.2811 14.3032C3.09869 14.492 2.99776 14.745 3.00004 15.0075C3.00232 15.27 3.10763 15.5211 3.29329 15.7067C3.47896 15.8924 3.73011 15.9977 3.99267 16C4.25522 16.0022 4.50817 15.9013 4.69703 15.7189L12 8.41697L13.0014 9.4182L19.303 15.7189C19.4918 15.9013 19.7448 16.0022 20.0073 16C20.2699 15.9977 20.521 15.8924 20.7067 15.7067C20.8924 15.5211 20.9977 15.27 21 15.0075Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpLg);
export default __webpack_public_path__ + "static/media/up-lg.61330427f62fc8fff16a1dc5db298c96.svg";
export { ForwardRef as ReactComponent };